export const siteConfig = {
  name: "91.n",
  tagline: "值得信赖的网络导航入口",
  description: "91.n 是您值得信赖的网络导航入口，提供快速、安全、便捷的访问体验。汇聚核心功能介绍、使用指南及常见问题解答，帮助用户第一时间找到所需资源。",
  url: "https://91.n",
  logo: "91.n",
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "分类导航", path: "/category/all" },
  { label: "使用指南", path: "/article/guide" },
  { label: "关于我们", path: "/about" },
];

export const categories = [
  { slug: "all", name: "全部", icon: "ri-apps-line", description: "浏览全部导航资源" },
  { slug: "search", name: "搜索引擎", icon: "ri-search-eye-line", description: "主流搜索引擎入口集合" },
  { slug: "news", name: "新闻资讯", icon: "ri-newspaper-line", description: "权威新闻媒体与资讯平台" },
  { slug: "video", name: "视频娱乐", icon: "ri-live-line", description: "热门视频与娱乐平台导航" },
  { slug: "shopping", name: "购物电商", icon: "ri-shopping-bag-3-line", description: "综合与垂直电商平台入口" },
  { slug: "social", name: "社交社区", icon: "ri-group-line", description: "社交网络与社区讨论平台" },
  { slug: "tools", name: "实用工具", icon: "ri-tools-line", description: "在线工具与效率应用集合" },
  { slug: "study", name: "学习教育", icon: "ri-book-open-line", description: "在线教育与知识学习平台" },
];

export const resources = [
  {
    id: 1,
    title: "百度搜索",
    slug: "baidu",
    category: "search",
    description: "全球最大的中文搜索引擎，提供网页、图片、视频等多种搜索服务。",
    url: "https://www.baidu.com",
    icon: "ri-global-line",
    tags: ["搜索", "中文", "综合"],
    featured: true,
  },
  {
    id: 2,
    title: "必应搜索",
    slug: "bing",
    category: "search",
    description: "微软推出的国际搜索引擎，界面精美，搜索体验优秀。",
    url: "https://www.bing.com",
    icon: "ri-window-line",
    tags: ["搜索", "国际", "AI"],
    featured: true,
  },
  {
    id: 3,
    title: "Google 搜索",
    slug: "google",
    category: "search",
    description: "全球领先的搜索引擎，提供强大的信息检索能力。",
    url: "https://www.google.com",
    icon: "ri-google-line",
    tags: ["搜索", "全球", "学术"],
    featured: false,
  },
  {
    id: 4,
    title: "新浪新闻",
    slug: "sina-news",
    category: "news",
    description: "国内领先的新闻门户，提供全天候新闻资讯服务。",
    url: "https://news.sina.com.cn",
    icon: "ri-article-line",
    tags: ["新闻", "综合", "实时"],
    featured: true,
  },
  {
    id: 5,
    title: "澎湃新闻",
    slug: "thepaper",
    category: "news",
    description: "专注时政与思想的互联网新闻平台，深度报道见长。",
    url: "https://www.thepaper.cn",
    icon: "ri-pages-line",
    tags: ["新闻", "深度", "时政"],
    featured: true,
  },
  {
    id: 6,
    title: "网易新闻",
    slug: "netease-news",
    category: "news",
    description: "网易旗下新闻资讯平台，汇聚海量优质内容。",
    url: "https://news.163.com",
    icon: "ri-newspaper-line",
    tags: ["新闻", "综合", "跟帖"],
    featured: false,
  },
  {
    id: 7,
    title: "哔哩哔哩",
    slug: "bilibili",
    category: "video",
    description: "国内知名的视频弹幕网站，涵盖动画、游戏、知识等多元内容。",
    url: "https://www.bilibili.com",
    icon: "ri-tv-line",
    tags: ["视频", "弹幕", "社区"],
    featured: true,
  },
  {
    id: 8,
    title: "优酷视频",
    slug: "youku",
    category: "video",
    description: "阿里巴巴旗下视频平台，提供丰富影视综艺内容。",
    url: "https://www.youku.com",
    icon: "ri-play-circle-line",
    tags: ["视频", "影视", "综艺"],
    featured: true,
  },
  {
    id: 9,
    title: "腾讯视频",
    slug: "tencent-video",
    category: "video",
    description: "腾讯旗下在线视频媒体平台，热门剧集综艺全覆盖。",
    url: "https://v.qq.com",
    icon: "ri-vidicon-line",
    tags: ["视频", "剧集", "会员"],
    featured: false,
  },
  {
    id: 10,
    title: "淘宝网",
    slug: "taobao",
    category: "shopping",
    description: "阿里巴巴旗下C2C电商平台，商品种类丰富齐全。",
    url: "https://www.taobao.com",
    icon: "ri-shopping-cart-line",
    tags: ["购物", "C2C", "综合"],
    featured: true,
  },
  {
    id: 11,
    title: "京东商城",
    slug: "jd",
    category: "shopping",
    description: "自营电商领导者，正品保障，物流配送高效快捷。",
    url: "https://www.jd.com",
    icon: "ri-store-2-line",
    tags: ["购物", "自营", "物流"],
    featured: true,
  },
  {
    id: 12,
    title: "拼多多",
    slug: "pinduoduo",
    category: "shopping",
    description: "新电商开创者，主打社交拼团购物模式。",
    url: "https://www.pinduoduo.com",
    icon: "ri-price-tag-3-line",
    tags: ["购物", "拼团", "实惠"],
    featured: false,
  },
  {
    id: 13,
    title: "微信",
    slug: "wechat",
    category: "social",
    description: "腾讯旗下即时通讯与社交平台，连接超过十亿用户。",
    url: "https://weixin.qq.com",
    icon: "ri-wechat-line",
    tags: ["社交", "即时通讯", "支付"],
    featured: true,
  },
  {
    id: 14,
    title: "微博",
    slug: "weibo",
    category: "social",
    description: "国内最大的社交媒体平台之一，热点话题聚集地。",
    url: "https://weibo.com",
    icon: "ri-chat-smile-2-line",
    tags: ["社交", "热搜", "媒体"],
    featured: true,
  },
  {
    id: 15,
    title: "知乎",
    slug: "zhihu",
    category: "social",
    description: "中文互联网高质量问答社区与创作者聚集平台。",
    url: "https://www.zhihu.com",
    icon: "ri-question-answer-line",
    tags: ["社区", "问答", "知识"],
    featured: true,
  },
  {
    id: 16,
    title: "在线翻译",
    slug: "translate",
    category: "tools",
    description: "多语种在线翻译工具，支持文本、文档快速翻译。",
    url: "https://translate.google.cn",
    icon: "ri-translate-2",
    tags: ["工具", "翻译", "多语种"],
    featured: true,
  },
  {
    id: 17,
    title: "在线PS",
    slug: "online-ps",
    category: "tools",
    description: "在线图片编辑工具，无需安装即可实现修图设计。",
    url: "https://www.gaoding.com",
    icon: "ri-image-edit-line",
    tags: ["工具", "设计", "图片"],
    featured: false,
  },
  {
    id: 18,
    title: "腾讯文档",
    slug: "tencent-docs",
    category: "tools",
    description: "在线协作文档工具，支持多人实时编辑与分享。",
    url: "https://docs.qq.com",
    icon: "ri-file-text-line",
    tags: ["工具", "协作", "文档"],
    featured: true,
  },
  {
    id: 19,
    title: "中国大学MOOC",
    slug: "icourse",
    category: "study",
    description: "国内最大的中文慕课平台，汇聚名校优质课程。",
    url: "https://www.icourse163.org",
    icon: "ri-graduation-cap-line",
    tags: ["教育", "慕课", "名校"],
    featured: true,
  },
  {
    id: 20,
    title: "网易公开课",
    slug: "open-course",
    category: "study",
    description: "汇集全球名校公开课与TED演讲，开拓视野。",
    url: "https://open.163.com",
    icon: "ri-video-line",
    tags: ["教育", "公开课", "TED"],
    featured: true,
  },
  {
    id: 21,
    title: "豆瓣",
    slug: "douban",
    category: "social",
    description: "书影音评分与社区交流平台，发现好内容。",
    url: "https://www.douban.com",
    icon: "ri-star-line",
    tags: ["社区", "书影音", "评分"],
    featured: false,
  },
  {
    id: 22,
    title: "GitHub",
    slug: "github",
    category: "tools",
    description: "全球最大的代码托管与开发者协作平台。",
    url: "https://github.com",
    icon: "ri-github-line",
    tags: ["工具", "开发", "开源"],
    featured: false,
  },
  {
    id: 23,
    title: "抖音",
    slug: "douyin",
    category: "video",
    description: "字节跳动旗下短视频社交平台，记录美好生活。",
    url: "https://www.douyin.com",
    icon: "ri-music-line",
    tags: ["视频", "短视频", "创作"],
    featured: false,
  },
  {
    id: 24,
    title: "小红书",
    slug: "xiaohongshu",
    category: "shopping",
    description: "生活方式分享社区与消费决策入口。",
    url: "https://www.xiaohongshu.com",
    icon: "ri-booklet-line",
    tags: ["社区", "种草", "生活"],
    featured: true,
  },
];

export const articles = [
  {
    id: 1,
    title: "91.n 使用指南：快速上手导航入口",
    slug: "guide",
    category: "guide",
    excerpt: "本文详细介绍 91.n 的各项功能与使用技巧，帮助您快速上手，高效利用导航资源。",
    content: `## 欢迎使用 91.n

91.n 是一款精心设计的网络导航入口工具，旨在帮助您快速找到所需的互联网资源。

### 核心功能

1. **分类导航**：我们按照搜索引擎、新闻资讯、视频娱乐、购物电商、社交社区、实用工具、学习教育等八大类别，精心整理了上百个优质网站入口。

2. **智能推荐**：根据资源的热门程度和用户口碑，我们在首页为您推荐最受欢迎的导航链接。

3. **快速搜索**：首页内置搜索框，支持关键词快速检索导航资源，一键直达目标网站。

### 使用技巧

- **收藏常用资源**：在分类页面找到常用资源后，可使用浏览器的收藏功能将其保存。
- **定期访问**：建议将 91.n 设为浏览器主页，每次打开浏览器即可快速访问所需资源。
- **反馈建议**：如发现链接失效或有新增资源建议，欢迎通过关于我们页面的联系方式反馈。

### 安全提示

91.n 对所有收录链接进行定期检查，但建议用户在访问陌生网站时保持警惕，注意个人信息安全。`,
    createdAt: "2026-07-15",
    readTime: "5分钟",
    tags: ["使用指南", "入门", "教程"],
  },
  {
    id: 2,
    title: "网络导航入口的价值与选择指南",
    slug: "value-guide",
    category: "guide",
    excerpt: "了解网络导航入口的核心价值，以及如何选择一个可靠、高效的导航服务平台。",
    content: `## 网络导航入口的价值

在信息爆炸的互联网时代，一个优质的网络导航入口能够极大地提升您的上网效率。

### 为什么需要导航入口

1. **节省时间**：无需记忆大量网址，一键直达常用网站。
2. **发现优质资源**：精心筛选的网站列表，帮助您发现更多有价值的网络资源。
3. **分类管理**：按类别整理网站，让您的上网体验更加有序。

### 如何选择导航入口

- **资源质量**：收录的网站是否经过筛选，链接是否可靠。
- **更新频率**：是否定期更新和检查链接有效性。
- **分类清晰**：分类是否合理，是否便于查找。
- **安全性**：链接是否经过安全检查，是否存在钓鱼网站风险。

### 91.n 的优势

91.n 致力于为用户提供安全、便捷、高效的导航服务。我们坚持人工审核与自动检测相结合，确保每一个收录链接的安全可靠。`,
    createdAt: "2026-07-20",
    readTime: "4分钟",
    tags: ["导航", "入门", "选择"],
  },
  {
    id: 3,
    title: "91.n 最新访问方法与地址更新说明",
    slug: "access-methods",
    category: "guide",
    excerpt: "了解 91.n 的最新访问地址与方法，确保您随时随地都能稳定访问导航服务。",
    content: `## 91.n 访问方法

为确保您能稳定访问 91.n，我们提供以下访问方式：

### 推荐访问方式

1. **直接访问**：在浏览器地址栏输入官方域名即可访问。
2. **设为首页**：将 91.n 设为浏览器主页，每次启动浏览器自动打开。
3. **添加到收藏夹**：使用浏览器的收藏功能（Ctrl+D）将本站添加至收藏夹。

### 地址更新说明

91.n 官方域名长期有效。如遇域名变更，我们会通过以下渠道及时通知：

- 官方社交媒体账号
- 合作伙伴平台
- 邮件通知（已订阅用户）

### 访问故障排查

如遇无法访问的情况，请尝试：

1. 检查网络连接是否正常
2. 清除浏览器缓存后重试
3. 尝试使用其他浏览器访问
4. 联系技术支持获取帮助`,
    createdAt: "2026-08-01",
    readTime: "3分钟",
    tags: ["访问", "地址", "帮助"],
  },
];

export const faqs = [
  {
    question: "91.n 是什么？",
    answer: "91.n 是一个专业的网络导航入口平台，为您提供分类清晰、资源丰富的网站导航服务。我们精心收录了搜索引擎、新闻资讯、视频娱乐、购物电商、社交社区、实用工具、学习教育等领域的优质网站，帮助您快速找到所需资源。",
  },
  {
    question: "91.n 是免费使用的吗？",
    answer: "是的，91.n 完全免费。我们的目标是让每一位用户都能享受便捷高效的网络导航服务，无需支付任何费用。",
  },
  {
    question: "如何找到 91.n 的最新访问地址？",
    answer: "您可以直接访问我们的官方域名。如域名有更新，我们会通过官方网站公告、社交媒体等渠道及时通知用户。建议您将本站加入浏览器收藏夹以便随时访问。",
  },
  {
    question: "91.n 收录的网站安全吗？",
    answer: "我们对所有收录的网站进行严格的审核和定期检查，确保链接的有效性和安全性。同时，我们也建议用户在访问任何网站时保持基本的安全意识，不随意输入个人敏感信息。",
  },
  {
    question: "可以推荐网站加入 91.n 的导航列表吗？",
    answer: "当然可以！我们非常欢迎用户推荐优质网站。请通过「关于我们」页面的联系方式提交您的推荐，我们的团队会进行审核评估。",
  },
  {
    question: "91.n 在手机端可以使用吗？",
    answer: "可以。91.n 采用响应式设计，完美适配手机、平板和桌面设备。无论您使用什么设备，都能获得一致且流畅的导航体验。",
  },
  {
    question: "91.n 会收集用户的个人隐私信息吗？",
    answer: "91.n 高度重视用户隐私保护。我们不要求用户注册登录，也不会收集任何个人身份信息。详细的隐私政策请参阅相关说明。",
  },
];

export const features = [
  {
    icon: "ri-speed-up-line",
    title: "极速访问",
    description: "页面极致轻量，加载速度飞快，一键直达目标网站",
  },
  {
    icon: "ri-shield-check-line",
    title: "安全可靠",
    description: "所有收录链接经过严格审核，定期检查确保链接安全有效",
  },
  {
    icon: "ri-stack-line",
    title: "分类清晰",
    description: "八大分类体系，让您轻松找到所需的各类网络资源",
  },
  {
    icon: "ri-device-line",
    title: "全平台适配",
    description: "响应式设计完美适配电脑、平板、手机等各类设备",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    description: "定期更新资源库，及时添加新站点、清理失效链接",
  },
  {
    icon: "ri-user-heart-line",
    title: "用户至上",
    description: "以用户体验为核心，界面简洁直观，无需学习即可上手",
  },
];

export const aboutInfo = {
  brandName: "91.n",
  brandIntro: "91.n 是一个致力于为用户提供高效、安全、便捷网络导航服务的专业平台。自上线以来，我们始终坚持「用户至上」的理念，精心筛选和整理优质网络资源，帮助数百万用户快速找到所需信息。",
  mission: "让每个人都能轻松畅游互联网，是 91.n 始终不变的使命。",
  stats: [
    { value: "200+", label: "收录网站" },
    { value: "8", label: "分类板块" },
    { value: "10万+", label: "日访问量" },
    { value: "99.9%", label: "服务可用率" },
  ],
  reputation: [
    { title: "权威收录", description: "91.n 已被多个主流浏览器和导航平台收录推荐，成为用户信赖的上网入口。" },
    { title: "用户口碑", description: "凭借简洁的界面设计和丰富的资源，91.n 获得了广大用户的一致好评。" },
    { title: "安全认证", description: "我们严格遵守互联网安全规范，确保平台运行稳定、用户信息安全。" },
    { title: "持续运营", description: "91.n 拥有专业的技术和运营团队，保障平台的长期稳定运行和内容更新。" },
  ],
  contact: {
    email: "contact@91.n",
    wechat: "91n_official",
    feedback: "如您有任何建议、反馈或合作意向，欢迎通过以上方式联系我们。我们会在收到信息后的 24 小时内回复。",
  },
};

export const testimonials = [
  {
    content: "自从把 91.n 设为浏览器首页后，找各种网站方便太多了，分类清晰，界面干净，非常推荐！",
    author: "张先生",
    role: "自由职业者",
  },
  {
    content: "作为互联网从业者，每天要访问很多网站。91.n 帮我节省了大量时间，资源非常全面。",
    author: "李女士",
    role: "产品经理",
  },
  {
    content: "界面简洁大方，没有广告干扰，加载速度也很快。已经推荐给身边所有朋友了。",
    author: "王同学",
    role: "大学生",
  },
];